export default __webpack_public_path__ + "static/media/profile-fun-fact.a69f59bf.svg";